module.exports = __webpack_public_path__ + "static/media/foere-f.1d6a2402.mp3";